var maybeMarkAllCheckboxesAsChecked, maybeMarkCheckboxesAsChecked;

$(document).on('change', '[data-role~=all_entities_checkbox]', function() {
  return maybeMarkAllCheckboxesAsChecked('single_entity_checkbox', this);
});

$(document).on('change', '[data-role~=all_cards_checkbox]', function() {
  return maybeMarkAllCheckboxesAsChecked('mass_select_checkbox', this);
});

$(document).on('change', '[data-role~=single_entity_checkbox]', function() {
  return maybeMarkCheckboxesAsChecked('single_entity_checkbox', 'all_entities_checkbox', this);
});

$(document).on('change', '[data-role~=mass_select_checkbox]', function() {
  return maybeMarkCheckboxesAsChecked('mass_select_checkbox', 'all_cards_checkbox', this);
});

maybeMarkAllCheckboxesAsChecked = function(single_selector, elem) {
  if (elem.checked) {
    return $(`[data-role~=${single_selector}]`).not('[disabled]').each(function() {
      this.checked = true;
    });
  } else {
    return $(`[data-role~=${single_selector}]`).not('[disabled]').each(function() {
      this.checked = false;
    });
  }
};

maybeMarkCheckboxesAsChecked = function(single_selector, all_selector, elem) {
  var allCheckbox, allCheckboxes, checkedCheckboxes;
  checkedCheckboxes = $(`[data-role~=${single_selector}]:checked`);
  allCheckboxes = $(`[data-role~=${single_selector}]`);
  allCheckbox = $(`[data-role~=${all_selector}]`);
  if (false === $(elem).prop('checked')) {
    if ($(`[data-role~=${single_selector}]:checked`).length > 0) {
      allCheckbox.prop('indeterminate', true);
    } else {
      allCheckbox.prop('indeterminate', false);
      allCheckbox.prop('checked', false);
    }
  }
  if (true === $(elem).prop('checked')) {
    if (checkedCheckboxes.length > 0 && checkedCheckboxes.length !== allCheckboxes.length) {
      allCheckbox.prop('indeterminate', true);
    } else {
      allCheckbox.prop('indeterminate', false);
      allCheckbox.prop('checked', true);
    }
  }
  if (checkedCheckboxes.length === allCheckboxes.length) {
    allCheckbox.prop('indeterminate', false);
    allCheckbox.prop('checked', true);
  }
};
